import React from 'react';
import { Navigate } from 'react-router-dom';

export default function AuthRoute ({children}) {
  const loggedIn = localStorage.getItem('access_token') ? true : false; 
  return (
    loggedIn ? children : <Navigate to="/login" />
  )
}
